import { JsonSchemaValidator } from "@common/json-schema-validator";
import {
  CaptionLowerThirdHeight,
  CaptionLowerThirdUrl,
  CaptionLowerThirdWidth
} from "../../interface";
import {
  captionLowerThirdHeight,
  captionLowerThirdUrl,
  captionLowerThirdWidth
} from "../../schema";

export class MixerCaptionLowerThirdSetCmd {
  private static validation = JsonSchemaValidator.compile(
    MixerCaptionLowerThirdSetCmd.validationSchema()
  );

  readonly value: MixerCaptionLowerThirdSet;

  constructor(value: MixerCaptionLowerThirdSet) {
    this.value = JsonSchemaValidator.assert(
      MixerCaptionLowerThirdSetCmd.validation,
      value
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: [
        "captionLowerThirdUrl",
        "captionLowerThirdWidth",
        "captionLowerThirdHeight"
      ],
      properties: {
        captionLowerThirdUrl,
        captionLowerThirdWidth,
        captionLowerThirdHeight
      },
      additionalProperties: false
    };
  }
}

interface MixerCaptionLowerThirdSet {
  captionLowerThirdUrl: CaptionLowerThirdUrl;
  captionLowerThirdWidth: CaptionLowerThirdWidth;
  captionLowerThirdHeight: CaptionLowerThirdHeight;
}
